import { T, useTheme, dens, Ico, Eyebrow } from '../design';
import type { IconName } from '../design';

type ModuleStatus = 'active' | 'external';
interface ModuleDef {
  key: string; name: string; desc: string; icon: IconName; tone: string;
  status: ModuleStatus; href?: string;
}

const MODULES: ModuleDef[] = [
  { key: 'claims-list', name: 'Reklamationer', desc: 'Opret og følg reklamationer for salonen', icon: 'receipt', tone: 'sage', status: 'active' },
  { key: 'kurser', name: 'Kurser', desc: 'Tilmeld kurser, godkend og se holdet', icon: 'book', tone: 'forrest', status: 'active' },
  { key: 'medlem', name: 'Find PRIME-medlem', desc: 'Søg kunde, se fordele og inviter familie', icon: 'users', tone: 'forrest', status: 'active' },
  { key: 'prime', name: 'PRIME Statistik', desc: 'Medlemstal, udvikling og saloner', icon: 'star', tone: 'sage', status: 'active' },
];

export interface LauncherProps {
  employeeName: string;
  salonName: string;
  onOpen: (key: string) => void;
}

export function Launcher({ employeeName, salonName, onOpen }: LauncherProps) {
  const t = useTheme();
  const d = dens(t);
  const hour = new Date().getHours();
  const greet = hour < 10 ? 'Godmorgen' : hour < 18 ? 'Goddag' : 'Godaften';
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ paddingTop: 4 }}>
        <div style={{ fontSize: 13, color: T.fg3, fontWeight: 700 }}>{greet},</div>
        <div style={{ fontSize: 26, fontWeight: 800, color: T.fg, letterSpacing: '-0.02em', marginTop: 2 }}>{employeeName.split(' ')[0]}</div>
        <div style={{ fontSize: 13, color: T.fg2, fontWeight: 600, marginTop: 4, display: 'flex', alignItems: 'center', gap: 6 }}><Ico.store size={15} style={{ color: t.accent }} />{salonName}</div>
      </div>
      <div>
        <Eyebrow style={{ marginBottom: 12 }}>Vælg modul</Eyebrow>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: d.gap }}>
          {MODULES.map((m) => {
            const Ic = Ico[m.icon];
            const live = m.status === 'active' || m.status === 'external';
            const onClick = () => {
              if (m.status === 'external') { window.location.href = m.href!; return; }
              onOpen(m.key);
            };
            return (
              <button key={m.key} onClick={onClick} style={{ position: 'relative', textAlign: 'left', display: 'flex', flexDirection: 'column', padding: 16, minHeight: 152, borderRadius: t.radius + 4, border: `1px solid ${T.border}`, background: live ? T.surface : T.surface, cursor: 'pointer', fontFamily: T.font, opacity: live ? 1 : 0.78 }}>
                <span style={{ width: 44, height: 44, borderRadius: 13, background: !live ? T.track : m.tone === 'forrest' ? T.dark : T.accentLight, color: !live ? T.fg3 : m.tone === 'forrest' ? T.accentLight : T.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 }}><Ic size={22} /></span>
                <span style={{ fontSize: 15, fontWeight: 800, color: T.fg, letterSpacing: '-0.01em' }}>{m.name}</span>
                <span style={{ fontSize: 11.5, color: T.fg3, fontWeight: 600, marginTop: 4, lineHeight: 1.4, flex: 1 }}>{m.desc}</span>
                {live && <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 10, fontSize: 12, fontWeight: 700, color: t.accent }}>Åbn <Ico.arrowR size={14} /></span>}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
